import { Controller } from "@hotwired/stimulus"

// Listens for a barcode scan/enter, calls the lookup endpoint,
// then puts the returned product_reference into the search input.
export default class extends Controller {
  static targets = ["barcodeInput", "searchInput", "feedback"]
  static values  = { url: String, networkError: String }

  // Called via data-action="barcode-scanner:scanned->barcode-lookup#lookup"
  // (event bubbles up from the nested barcode-scanner controller)
  lookup(event) {
    this._doLookup(event.detail.code)
  }

  async _doLookup(barcode) {
    if (!barcode || !this.urlValue) return

    this._clearFeedback()

    try {
      const resp = await fetch(`${this.urlValue}?barcode=${encodeURIComponent(barcode)}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })

      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status}`)
      }

      const data = await resp.json()

      if (data.found) {
        this.searchInputTarget.value = data.product_reference
        this.searchInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
        this.barcodeInputTarget.value = ''
      } else {
        this._showFeedback(data.message)
      }
    } catch (err) {
      console.error('barcode-lookup fetch error:', err)
      this._showFeedback(this.networkErrorValue || '❌ Connection error')
    }
  }

  _showFeedback(msg) {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = msg
      this.feedbackTarget.classList.remove('d-none')
    }
  }

  _clearFeedback() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = ''
      this.feedbackTarget.classList.add('d-none')
    }
  }
}
